module.exports = __webpack_public_path__ + "img/page4@2x.0aa85259.png";